import React, {useState, useEffect} from "react";
import {Link, useLocation} from "react-router-dom";
import {useSelector, useDispatch} from "react-redux";
import {userCan, userCanAny} from "../Helpers/Utils";
import {confirmAlert, errorAlert} from "../Alerts/BasicAlert";
import axios from "axios";
import swal from "sweetalert";

const firstUrl = window.location.pathname.replace(/^\/([^\/]*).*$/, '$1');

export default function () {

  const user = useSelector(state => state.user);
  const permissions = useSelector(state => state.user?.permissions);
  const menuOpen = useSelector(state => state.menuOpenClose);
  const isAdmin = user?.roles?.includes('Super Admin');
  const isSeller = user?.roles?.includes('Seller');
  const pathName = window.location.pathname;

  const location = useLocation();
  const dispatch = useDispatch();

  const [activeLinkName, setActiveLinkName] = useState(firstUrl);

  const settingsLinks = [
    "profit-margins",
    "general-settings",
    "contact-details",
    "pages",
    "banners",
    "sliders",
    "main-sliders",
    "best-selling-products",
    "continue-shopping",
    "deal-of-the-day",
    "delivery-prices",
    "seo",
    "cashback-rules",
  ];

  const dashboardLinks = [
    "/dashboard",
    "/dashboard/recent-orders",
    "/dashboard/top-products"
  ];

  const permissionsToSeeSettings = [
    'Profit Margin View',
    'General Settings View',
    'Contact Details View',
    'Page View',
    'Static Page View',
    'Banner View',
    'Slider View',
    'Main Slider View',
    'Best Selling Products View',
    'Continue Shopping View',
    'Deal Of The Day View',
    'Delivery Price View',
    'Cashback Rules View',
  ];

  const returnPascalcase = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  useEffect(() => {
    let url = window.location.href;
    var urlArray = url.split('/');
    var urlArray = urlArray.splice(3, urlArray.length - 1);
    let pascalcaseUrl = returnPascalcase(urlArray[0]);
    document.getElementById("pageTitle").innerText = pascalcaseUrl;

    let urlArrayLength = urlArray.length;
    let breadcrumbOutput = "";
    for (let i = 1; i < urlArrayLength; i++) {
      breadcrumbOutput += ">> " + returnPascalcase(urlArray[i]) + " ";
    }

    document.getElementById("breadcrumbs").innerText = breadcrumbOutput;

    let changedUrlFirstSegment = window.location.pathname.replace(/^\/([^\/]*).*$/, '$1');
    setActiveLinkName(changedUrlFirstSegment);

  }, [activeLinkName, location]);


  const clearCache = () => {
    confirmAlert('Do you want to clear all cache?', () => {
      axios.delete(`/caches`).then(res => {
        if (res.data.status === 'success') {
          swal('Cache has been cleared successfully!', {
            icon: "success",
          });
        } else {
          errorAlert(res.data?.message);
        }
      }).catch(err => {
        const message = err.response?.data?.message;

        if (message) {
          errorAlert(message);
        }
      });
    });
  }

  return (
    <>
      <div id="kt_aside" className={`aside menu-parent-tag${menuOpen ? "" : " closed"}`} data-kt-drawer="true"
           data-kt-drawer-name="aside"
           data-kt-drawer-activate="{default: true, lg: false}" data-kt-drawer-overlay="true"
           data-kt-drawer-width="{default:'200px', '300px': '250px'}" data-kt-drawer-direction="start"
           data-kt-drawer-toggle="#kt_aside_mobile_toggle">
        {/*begin::Aside menu*/}
        <div className="aside-menu flex-column-fluid">
          {/*begin::Aside Menu*/}
          <div className="hover-scroll-overlay-y px-2 my-5 my-lg-5" id="kt_aside_menu_wrapper"
               data-kt-scroll="true"
               data-kt-scroll-height="auto"
               data-kt-scroll-dependencies="{default: '#kt_aside_toolbar, #kt_aside_footer', lg: '#kt_header, #kt_aside_toolbar, #kt_aside_footer'}"
               data-kt-scroll-offset={0}>
            {/*begin::Menu*/}
            <div
              className="menu menu-column menu-title-gray-800 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-500 fw-bold"
              id="kt_aside_menu" data-kt-menu="true">

              {
                (isAdmin || isSeller || userCan(permissions, 'Dashboard View')) && (
                  <div
                    className={`menu-item menu-accordion${activeLinkName === 'dashboard' ? ' expanded' : ''}`}
                    onClick={(event) => {
                      event.currentTarget.classList.toggle('expanded')
                    }}>
                    <div
                      className={`menu-link${activeLinkName === 'dashboard' ? ' active-link' : ''}`}
                    >
                      <div className="menu-icon">
                        <i className="fas fa-chart-line"></i>
                      </div>
                      <span className="menu-title">Dashboard</span>
                    </div>

                    <div className="submenu ml-3 pl-3">
                      <Link to="/dashboard"
                            className={`menu-link${pathName === '/dashboard' ? ' active-link' : ''}`}
                            onClick={() => {
                              setActiveLinkName("dashboard")
                            }}
                      >
                        <div className="menu-icon">
                          <i className="fas fa-chart-line"></i>
                        </div>
                        <span className="menu-title">General</span>
                      </Link>
                    </div>

                    <div className="submenu ml-3 pl-3">
                      <Link to="/dashboard/recent-orders"
                            className={`menu-link${pathName === '/dashboard/recent-orders' ? ' active-link' : ''}`}
                            onClick={() => {
                              setActiveLinkName("recent-orders")
                            }}
                      >
                        <div className="menu-icon">
                          <i className="fas fa-shopping-cart"></i>
                        </div>
                        <span className="menu-title">Recent Orders</span>
                      </Link>
                    </div>

                    <div className="submenu ml-3 pl-3">
                      <Link to="/dashboard/top-products"
                            className={`menu-link${pathName === '/dashboard/top-products' ? ' active-link' : ''}`}
                            onClick={() => {
                              setActiveLinkName("top-products")
                            }}
                      >
                        <div className="menu-icon">
                          <i className="fas fa-shopping-cart"></i>
                        </div>
                        <span className="menu-title">Top Products</span>
                      </Link>
                    </div>

                    <div className="submenu ml-3 pl-3">
                      <Link to="/dashboard/recent-feedbacks"
                            className={`menu-link${pathName === '/dashboard/recent-feedbacks' ? ' active-link' : ''}`}
                            onClick={() => {
                              setActiveLinkName("recent-feedbacks")
                            }}
                      >
                        <div className="menu-icon">
                          <i className="fas fa-comments"></i>
                        </div>
                        <span className="menu-title">Recent Reviews</span>
                      </Link>
                    </div>

                    <div className="submenu ml-3 pl-3">
                      <Link to="/dashboard/sales-by-category"
                            className={`menu-link${pathName === '/dashboard/sales-by-category' ? ' active-link' : ''}`}
                            onClick={() => {
                              setActiveLinkName("sales-by-category")
                            }}
                      >
                        <div className="menu-icon">
                          <i className="fas fa-shopping-cart"></i>
                        </div>
                        <span className="menu-title">Orders by category</span>
                      </Link>
                    </div>

                    <div className="submenu ml-3 pl-3">
                      <Link to="/dashboard/profit"
                            className={`menu-link${pathName === '/dashboard/profit' ? ' active-link' : ''}`}
                            onClick={() => {
                              setActiveLinkName("profit")
                            }}
                      >
                        <div className="menu-icon">
                          <i className="fas fa-chart-line"></i>
                        </div>
                        <span className="menu-title">Profit By Category</span>
                      </Link>
                    </div>

                    <div className="submenu ml-3 pl-3">
                      <Link to="/dashboard/refunds"
                            className={`menu-link${pathName === '/dashboard/refunds' ? ' active-link' : ''}`}
                            onClick={() => {
                              setActiveLinkName("refunds")
                            }}
                      >
                        <div className="menu-icon">
                          <i className="fas fa-chart-line"></i>
                        </div>
                        <span className="menu-title">Refunded Orders</span>
                      </Link>
                    </div>
                  </div>
                )
              }

              {
                (isAdmin || userCan(permissions, 'User View')) && (
                  <div className="menu-item">
                    <Link to="/admins"
                          className={`menu-link${activeLinkName == 'admins' ? ' active-link' : ''}`}
                          onClick={() => {
                            setActiveLinkName("Admins")
                          }}
                    >
                      <div className="menu-icon">
                        <i className="fas fa-user-shield"></i>
                      </div>
                      <span className="menu-title">Admins</span>
                    </Link>
                  </div>
                )
              }

              {
                (isAdmin || userCan(permissions, 'Brand View')) && (
                  <div className="menu-item">
                    <Link to="/brands"
                          className={`menu-link${activeLinkName == 'brands' ? ' active-link' : ''}`}
                          onClick={() => {
                            setActiveLinkName("Brands")
                          }}
                    >
                      <div className="menu-icon">
                        <i className="fas fa-fire-alt"></i>
                      </div>
                      <span className="menu-title">Brands</span>
                    </Link>
                  </div>
                )
              }

              {
                (isAdmin || userCan(permissions, 'Category View')) && (
                  <div className="menu-item">
                    <Link to="/categories/tree"
                          className={`menu-link${activeLinkName == 'categories' ? ' active-link' : ''}`}
                          onClick={() => {
                            setActiveLinkName("Categories")
                          }}
                    >
                      <div className="menu-icon">
                        <i className="fas fa-stream"></i>
                      </div>
                      <span className="menu-title">Categories</span>
                    </Link>
                  </div>
                )
              }

              {
                (isAdmin || userCan(permissions, 'Customer View')) && (
                  <div className="menu-item">
                    <Link to="/customers"
                          className={`menu-link${activeLinkName == 'customers' ? ' active-link' : ''}`}
                          onClick={() => {
                            setActiveLinkName("Customers")
                          }}
                    >
                      <div className="menu-icon">
                        <i className="fa fa-users"></i>
                      </div>
                      <span className="menu-title">Customers</span>
                    </Link>
                  </div>
                )
              }

              {
                (isAdmin || isSeller || userCan(permissions, 'Order View')) && (
                  <div
                    className={`menu-item menu-accordion${activeLinkName == 'orders' ? ' expanded' : ''}`}
                    onClick={(event) => {
                      if (activeLinkName != 'orders') {
                        event.currentTarget.classList.toggle('expanded')
                      }
                    }}
                  >
                    <Link to="/orders"
                          className={`menu-link d-block${activeLinkName == 'orders' ? ' active-link' : ''}`}
                    >
                      <div
                        className={`menu-item d-block${activeLinkName == 'orders' ? ' active-link' : ''}`}
                        onClick={() => {
                          setActiveLinkName("orders")
                        }}
                      >
                        <div className="menu-icon d-inline-block">
                          <i className="fas fa-shopping-cart"></i>
                        </div>
                        <span className="menu-title d-inline-block">Orders</span>
                      </div>
                    </Link>
                    <div className="submenu ml-3 pl-3">
                      <Link to="/orders/statuses/all"
                            className={`menu-link${pathName == '/orders/statuses/all' ? ' active-link' : ''}`}
                            onClick={() => {
                              setActiveLinkName("all")
                            }}
                      >
                        <div className="menu-icon">
                          <i className="fas far fa-list"></i>
                        </div>
                        <span className="menu-title">All</span>
                      </Link>
                      <Link to="/orders/statuses/1"
                            className={`menu-link${pathName == '/orders/statuses/1' ? ' active-link' : ''}`}
                            onClick={() => {
                              setActiveLinkName("pending")
                            }}
                      >
                        <div className="menu-icon">
                          <i className="fas far fa-question-circle"></i>
                        </div>
                        <span className="menu-title">Pending</span>
                      </Link>
                      <Link to="/orders/statuses/2"
                            className={`menu-link${pathName == '/orders/statuses/2' ? ' active-link' : ''}`}
                            onClick={() => {
                              setActiveLinkName("active")
                            }}
                      >
                        <div className="menu-icon">
                          <i className="far fa-check-circle"></i>
                        </div>
                        <span className="menu-title">Active</span>
                      </Link>
                      <Link to="/orders/statuses/3"
                            className={`menu-link${pathName == '/orders/statuses/3' ? ' active-link' : ''}`}
                            onClick={() => {
                              setActiveLinkName("canceled")
                            }}
                      >
                        <div className="menu-icon">
                          <i className="fas fa-ban"></i>
                        </div>
                        <span className="menu-title">Canceled</span>
                      </Link>
                      <Link to="/orders/statuses/7"
                            className={`menu-link${pathName == '/orders/statuses/7' ? ' active-link' : ''}`}
                            onClick={() => {
                              setActiveLinkName("ready-for-shipment")
                            }}
                      >
                        <div className="menu-icon">
                          <i className="fas fa-truck"></i>
                        </div>
                        <span className="menu-title">Ready For Shipment</span>
                      </Link>
                      <Link to="/orders/statuses/4"
                            className={`menu-link${pathName == '/orders/statuses/4' ? ' active-link' : ''}`}
                            onClick={() => {
                              setActiveLinkName("delivered")
                            }}
                      >
                        <div className="menu-icon">
                          <i className="fas fa-map-marker-alt fs-2"></i>
                        </div>
                        <span className="menu-title">Delivered</span>
                      </Link>
                      <Link to="/orders/statuses/5"
                            className={`menu-link${pathName == '/orders/statuses/5' ? ' active-link' : ''}`}
                            onClick={() => {
                              setActiveLinkName("refund")
                            }}
                      >
                        <div className="menu-icon">
                          <i className="fas fa-comment-dollar"></i>
                        </div>
                        <span className="menu-title">Refund</span>
                      </Link>
                      <Link to="/orders/statuses/6"
                            className={`menu-link${pathName == '/orders/statuses/6' ? ' active-link' : ''}`}
                            onClick={() => {
                              setActiveLinkName("shipped")
                            }}
                      >
                        <div className="menu-icon">
                          <i className="fas fa-truck"></i>
                        </div>
                        <span className="menu-title">Shipped</span>
                      </Link>
                    </div>
                  </div>
                )
              }

              {
                (isAdmin || userCan(permissions, 'Shop View')) && (
                  <div className="menu-item">
                    <Link to="/shops"
                          className={`menu-link${activeLinkName == 'shops' ? ' active-link' : ''}`}
                          onClick={() => {
                            setActiveLinkName("Shops")
                          }}
                    >
                      <div className="menu-icon">
                        <i className="fas fa-comments-dollar"></i>
                      </div>
                      <span className="menu-title">Shops & Sellers</span>
                    </Link>
                  </div>
                )
              }

              {
                isSeller && (
                  <div className="menu-item">
                    <Link to="/sellers"
                          className={`menu-link${activeLinkName == 'sellers' ? ' active-link' : ''}`}
                          onClick={() => {
                            setActiveLinkName("sellers")
                          }}
                    >
                      <div className="menu-icon">
                        <i className="fas fa-comments-dollar"></i>
                      </div>
                      <span className="menu-title">Sellers</span>
                    </Link>
                  </div>
                )
              }

              {
                (isAdmin || userCan(permissions, 'Store View')) && (
                  <div className="menu-item">
                    <Link to="/stores"
                          className={`menu-link${activeLinkName == 'stores' ? ' active-link' : ''}`}
                          onClick={() => {
                            setActiveLinkName("Stores")
                          }}
                    >
                      <div className="menu-icon">
                        <i className="fas fa-store"></i>
                      </div>
                      <span className="menu-title">Stores</span>
                    </Link>
                  </div>
                )
              }

              {
                (isSeller || isAdmin || userCan(permissions, 'Product View')) && (
                  <div
                    className={`menu-item menu-accordion${activeLinkName == 'products' ? ' expanded' : ''}`}
                    onClick={(event) => {
                      if (activeLinkName != 'products') {
                        event.currentTarget.classList.toggle('expanded')
                      }
                    }}
                  >

                    <Link to="/products"
                          className={`menu-link d-block${activeLinkName == 'products' ? ' active-link' : ''}`}
                    >
                      <div
                        className={`menu-item d-block${activeLinkName == 'products' ? ' active-link' : ''}`}
                        onClick={() => {
                          setActiveLinkName("products")
                        }}
                      >
                        <div className="menu-icon d-inline-block">
                          <i className="fas fa-shopping-cart"></i>
                        </div>
                        <span className="menu-title d-inline-block">Products</span>
                      </div>
                    </Link>

                    {
                      (isAdmin || userCan(permissions, 'Product View')) && (
                        <div className="submenu ml-3 pl-3">
                          <Link to="/products/1"
                                className={`menu-link${pathName == '/products/1' ? ' active-link' : ''}`}
                                onClick={() => {
                                  setActiveLinkName("pending")
                                }}
                          >
                            <div className="menu-icon">
                              <i className="fas far fa-question-circle"></i>
                            </div>
                            <span className="menu-title">Pending</span>
                          </Link>
                          <Link to="/products/2"
                                className={`menu-link${pathName == '/products/2' ? ' active-link' : ''}`}
                                onClick={() => {
                                  setActiveLinkName("approved")
                                }}
                          >
                            <div className="menu-icon">
                              <i className="fas fa-check-circle"></i>
                            </div>
                            <span className="menu-title">Approved</span>
                          </Link>
                          <Link to="/products/3"
                                className={`menu-link${pathName == '/products/3' ? ' active-link' : ''}`}
                                onClick={() => {
                                  setActiveLinkName("rejected")
                                }}
                          >
                            <div className="menu-icon">
                              <i className="fas fa-times-circle"></i>
                            </div>
                            <span className="menu-title">Rejected</span>
                          </Link>
                          <Link to="/products/4"
                                className={`menu-link${pathName == '/products/4' ? ' active-link' : ''}`}
                                onClick={() => {
                                  setActiveLinkName("draft")
                                }}
                          >
                            <div className="menu-icon">
                              <i className="fas fa-stop-circle"></i>
                            </div>
                            <span className="menu-title">Drafted</span>
                          </Link>
                        </div>
                      )
                    }

                  </div>
                )
              }

              {
                (userCan(permissions, 'Advertisement View')) && (
                  <div
                    className={`menu-item menu-accordion${activeLinkName == 'advertisements' ? ' expanded' : ''}`}
                    onClick={(event) => {
                      if (activeLinkName != 'advertisements') {
                        event.currentTarget.classList.toggle('expanded')
                      }
                    }}
                  >
                    <Link to="/advertisements"
                          className={`menu-link d-block${activeLinkName == 'advertisements' ? ' active-link' : ''}`}
                    >
                      <div
                        className={`menu-item d-block${activeLinkName == 'advertisements' ? ' active-link' : ''}`}
                        onClick={() => {
                          setActiveLinkName("advertisements")
                        }}
                      >
                        <div className="menu-icon d-inline-block">
                          <i className="fas fa-ad top-3-px fs-2"></i>
                        </div>
                        <span className="menu-title d-inline-block">Products AD</span>
                      </div>
                    </Link>
                    {isAdmin &&
                      <div className="submenu ml-3 pl-3">
                      </div>
                    }
                  </div>
                )}

              {
                (isAdmin || userCan(permissions, 'Role View')) && (
                  <div className="menu-item">
                    <Link to="/roles"
                          className={`menu-link${activeLinkName == 'roles' ? ' active-link' : ''}`}
                          onClick={() => {
                            setActiveLinkName("settings")
                          }}
                    >
                      <div className="menu-icon">
                        <i className="fas fa-user-cog"></i>
                      </div>
                      <span className="menu-title">Roles</span>
                    </Link>
                  </div>
                )
              }

              {
                (isAdmin || userCanAny(permissions, permissionsToSeeSettings)) && (
                  <div
                    className={`menu-item menu-accordion${settingsLinks.includes(activeLinkName) ? ' expanded' : ''}`}
                    onClick={(event) => {
                      event.currentTarget.classList.toggle('expanded')
                    }}>

                    <div className={`menu-link${activeLinkName == 'settings' ? ' active-link' : ''}`}>
                      <div className="menu-icon">
                        <i className="fas fa-cog"></i>
                      </div>
                      <span className="menu-title">Settings</span>
                    </div>
                    {
                      (isAdmin || userCan(permissions, 'Profit Margin View')) && (
                        <div className="submenu ml-3 pl-3">
                          <Link to="/profit-margins"
                                className={`menu-link${activeLinkName == 'profit-margins' ? ' active-link' : ''}`}
                                onClick={() => {
                                  setActiveLinkName("Roles")
                                }}
                          >
                            <div className="menu-icon">
                              <i className="fas fa-percentage"></i>
                            </div>
                            <span className="menu-title">Profit Margins</span>
                          </Link>
                        </div>
                      )
                    }

                    {
                      (isAdmin || userCan(permissions, 'General Settings View')) && (
                        <div className="submenu ml-3 pl-3">
                          <Link to="/general-settings"
                                className={`menu-link${activeLinkName == 'general-settings' ? ' active-link' : ''}`}
                                onClick={() => {
                                  setActiveLinkName("Roles")
                                }}
                          >
                            <div className="menu-icon">
                              <i className="fas fa-cog"></i>
                            </div>
                            <span className="menu-title">General Settings</span>
                          </Link>
                        </div>
                      )
                    }

                    {
                      (isAdmin || userCan(permissions, 'Contact Details View')) && (
                        <div className="submenu ml-3 pl-3">
                          <Link to="/contact-details"
                                className={`menu-link${activeLinkName == 'contact-details' ? ' active-link' : ''}`}
                                onClick={() => {
                                  setActiveLinkName("Roles")
                                }}
                          >
                            <div className="menu-icon">
                              <i className="fa fa-address-card"></i>
                            </div>
                            <span className="menu-title">Contact Details</span>
                          </Link>
                        </div>
                      )
                    }

                    {
                      (isAdmin || userCan(permissions, 'Page View')) && (
                        <div className="submenu ml-3 pl-3">
                          <Link to="/pages"
                                className={`menu-link${activeLinkName == 'pages' ? ' active-link' : ''}`}
                                onClick={() => {
                                  setActiveLinkName("Roles")
                                }}
                          >
                            <div className="menu-icon">
                              <i className="fas fa-cog"></i>
                            </div>
                            <span className="menu-title">Page Settings</span>
                          </Link>
                        </div>

                      )
                    }

                    {
                      (isAdmin || userCan(permissions, 'Banner View')) && (
                        <div className="submenu ml-3 pl-3">
                          <Link to="/banners"
                                className={`menu-link${activeLinkName == 'banners' ? ' active-link' : ''}`}
                                onClick={() => {
                                  setActiveLinkName("Roles")
                                }}
                          >
                            <div className="menu-icon">
                              <i className="fas fa-image"></i>
                            </div>
                            <span className="menu-title">Banners</span>
                          </Link>
                        </div>

                      )
                    }

                    {
                      (isAdmin || userCan(permissions, 'Slider View')) && (
                        <div className="submenu ml-3 pl-3">
                          <Link to="/sliders"
                                className={`menu-link${activeLinkName == 'sliders' ? ' active-link' : ''}`}
                                onClick={() => {
                                  setActiveLinkName("Roles")
                                }}
                          >
                            <div className="menu-icon">
                              <i className="fas fa-images"></i>
                            </div>
                            <span className="menu-title">Sliders</span>
                          </Link>
                        </div>
                      )
                    }

                    {
                      (isAdmin || userCan(permissions, 'Main Slider View')) && (
                        <div className="submenu ml-3 pl-3">
                          <Link to="/main-sliders"
                                className={`menu-link${activeLinkName == 'main-sliders' ? ' active-link' : ''}`}
                                onClick={() => {
                                  setActiveLinkName("Roles")
                                }}
                          >
                            <div className="menu-icon">
                              <i className="fas fa-image"></i>
                            </div>
                            <span className="menu-title">Main slider</span>
                          </Link>
                        </div>
                      )
                    }

                    {
                      (isAdmin || userCan(permissions, 'Best Selling Products View')) && (
                        <div className="submenu ml-3 pl-3">
                          <Link to="/best-selling-products"
                                className={`menu-link${activeLinkName == 'best-selling-products' ? ' active-link' : ''}`}
                                onClick={() => {
                                  setActiveLinkName("Roles")
                                }}
                          >
                            <div className="menu-icon">
                              <i className="fas fa-star"></i>
                            </div>
                            <span className="menu-title fs-8">Best Selling Products</span>
                          </Link>
                        </div>
                      )
                    }

                    {
                      (isAdmin || userCan(permissions, 'Continue Shopping View')) && (
                        <div className="submenu ml-3 pl-3">
                          <Link to="/continue-shopping"
                                className={`menu-link${activeLinkName == 'continue-shopping' ? ' active-link' : ''}`}
                                onClick={() => {
                                  setActiveLinkName("Roles")
                                }}
                          >
                            <div className="menu-icon">
                              <i className="fas fa-history"></i>
                            </div>
                            <span className="menu-title">Continue Shopping</span>
                          </Link>
                        </div>
                      )
                    }

                    {
                      (isAdmin || userCan(permissions, 'Deal Of The Day View')) && (
                        <div className="submenu ml-3 pl-3">
                          <Link to="/deal-of-the-day"
                                className={`menu-link${activeLinkName == 'deal-of-the-day' ? ' active-link' : ''}`}
                                onClick={() => {
                                  setActiveLinkName("Roles")
                                }}
                          >
                            <div className="menu-icon">
                              <i className="fas fa-calendar-day"></i>
                            </div>
                            <span className="menu-title">Deal of The Day</span>
                          </Link>
                        </div>
                      )
                    }

                    {
                      (isAdmin || userCan(permissions, 'Cashback Rules View')) && (
                        <div className="submenu ml-3 pl-3">
                          <Link to="/cashback-rules"
                                className={`menu-link${activeLinkName == 'cashback-rules' ? ' active-link' : ''}`}
                                onClick={() => {
                                  setActiveLinkName("Roles")
                                }}
                          >
                            <div className="menu-icon">
                              <i className="fas fa-calendar-day"></i>
                            </div>
                            <span className="menu-title">Cashback Rules</span>
                          </Link>
                        </div>
                      )
                    }

                    {
                      (isAdmin || userCan(permissions, 'Delivery Price View')) && (
                        <div className="submenu ml-3 pl-3">
                          <Link to="/delivery-prices"
                                className={`menu-link${activeLinkName == 'delivery-prices' ? ' active-link' : ''}`}
                                onClick={() => {
                                  setActiveLinkName("delivery-prices")
                                }}
                          >
                            <div className="menu-icon">
                              <i className="fas fa-calendar-day"></i>
                            </div>
                            <span className="menu-title">Delivery</span>
                          </Link>
                        </div>
                      )
                    }
                    {
                        (isAdmin || userCan(permissions, 'Delivery Price View')) && (
                            <div className="submenu ml-3 pl-3">
                              <Link to="/delivery-information"
                                    className={`menu-link${activeLinkName === 'delivery-information' ? ' active-link' : ''}`}
                                    onClick={() => {
                                      setActiveLinkName("delivery-information")
                                    }}
                              >
                                <div className="menu-icon">
                                  <i className="fas fa-calendar-day"></i>
                                </div>
                                <span className="menu-title">Delivery information</span>
                              </Link>
                            </div>
                        )
                    }

                    {
                      (isAdmin || userCan(permissions, 'Static Page View') || userCan(permissions, 'Page View')) && (
                        <div className="submenu ml-3 pl-3">
                          <Link to="/seo"
                                className={`menu-link${activeLinkName == 'seo' ? ' active-link' : ''}`}
                                onClick={() => {
                                  setActiveLinkName("seo")
                                }}
                          >
                            <div className="menu-icon">
                              <i className="fas fa-search"></i>
                            </div>
                            <span className="menu-title">SEO</span>
                          </Link>
                        </div>
                      )
                    }
                  </div>
                )
              }

              {
                (isAdmin
                  || userCanAny(permissions,
                    [
                      'Import Products',
                      'Import Products Quantity',
                      'Import Products Prices',
                      'Import Products Categories',
                      'Import Products Keywords',
                      'Import Products Attributes',
                    ]
                  ))
                && (
                  <div
                    className={`menu-item menu-accordion${activeLinkName == 'imports' ? ' expanded' : ''}`}
                    onClick={(event) => {
                      event.currentTarget.classList.toggle('expanded')
                    }}>
                    <div
                      className={`menu-link${activeLinkName == 'imports' ? ' active-link' : ''}`}
                    >
                      <div className="menu-icon">
                        <i className="fas fa-upload"></i>
                      </div>
                      <span className="menu-title">Imports</span>
                    </div>

                    {
                      (isAdmin || userCan(permissions, 'Import Products')) && (
                        <div className="submenu ml-3 pl-3">
                          <Link to="/imports/products"
                                className={`menu-link${pathName == '/imports/products' ? ' active-link' : ''}`}
                                onClick={() => {
                                  setActiveLinkName("products")
                                }}
                          >
                            <div className="menu-icon">
                              <i className="fas fa-shopping-cart"></i>
                            </div>
                            <span className="menu-title">Products</span>
                          </Link>
                        </div>
                      )
                    }

                    {
                      (isAdmin || userCan(permissions, 'Import Products Quantity')) && (
                        <div className="submenu ml-3 pl-3">
                          <Link to="/imports/products-quantity"
                                className={`menu-link${pathName == '/imports/products-quantity' ? ' active-link' : ''}`}
                                onClick={() => {
                                  setActiveLinkName("products")
                                }}
                          >
                            <div className="menu-icon">
                              <i className="fas fa-percentage"></i>
                            </div>
                            <span className="menu-title">Products quantity</span>
                          </Link>
                        </div>
                      )
                    }

                    {
                      (isAdmin || userCan(permissions, 'Import Products Prices')) && (
                        <div className="submenu ml-3 pl-3">
                          <Link to="/imports/prices"
                                className={`menu-link${pathName == '/imports/prices' ? ' active-link' : ''}`}
                                onClick={() => {
                                  setActiveLinkName("products")
                                }}
                          >
                            <div className="menu-icon">
                              <i className="fas fa-percentage"></i>
                            </div>
                            <span className="menu-title">Products prices</span>
                          </Link>
                        </div>
                      )
                    }
                    {
                        (isAdmin || userCan(permissions, 'Import Products Images')) && (
                            <div className="submenu ml-3 pl-3">
                              <Link to="/imports/images"
                                    className={`menu-link${pathName == '/imports/images' ? ' active-link' : ''}`}
                                    onClick={() => {
                                      setActiveLinkName("products")
                                    }}
                              >
                                <div className="menu-icon">
                                  <i className="fas fa-percentage"></i>
                                </div>
                                <span className="menu-title">Products Images</span>
                              </Link>
                            </div>
                        )
                    }
                    {
                      (isAdmin || userCan(permissions, 'Import Products Categories')) && (
                        <div className="submenu ml-3 pl-3">
                          <Link to="/imports/categories"
                                className={`menu-link${pathName == '/imports/categories' ? ' active-link' : ''}`}
                                onClick={() => {
                                  setActiveLinkName("products")
                                }}
                          >
                            <div className="menu-icon">
                              <i className="fas fa-percentage"></i>
                            </div>
                            <span className="menu-title">Products categories</span>
                          </Link>
                        </div>
                      )
                    }
                    {
                      (isAdmin || isSeller || userCan(permissions, 'Import Products Keywords')) && (
                        <div className="submenu ml-3 pl-3">
                          <Link to="/imports/keywords"
                                className={`menu-link${pathName == '/imports/keywords' ? ' active-link' : ''}`}
                                onClick={() => {
                                  setActiveLinkName("products")
                                }}
                          >
                            <div className="menu-icon">
                              <i className="fas fa-percentage"></i>
                            </div>
                            <span className="menu-title">Products Keywords</span>
                          </Link>
                        </div>
                      )
                    }
                    {
                      (isAdmin || isSeller || userCan(permissions, 'Import Products Attributes')) && (
                        <div className="submenu ml-3 pl-3">
                          <Link to="/imports/product-attributes"
                                className={`menu-link${pathName == '/imports/product-attributes' ? ' active-link' : ''}`}
                                onClick={() => {
                                  setActiveLinkName("products")
                                }}
                          >
                            <div className="menu-icon">
                              <i className="fas fa-percentage"></i>
                            </div>
                            <span className="menu-title">Products Attributes</span>
                          </Link>
                        </div>
                      )
                    }
                  </div>
                )
              }

              {
                (userCan(permissions, 'Coupon View')) && (
                  <div className="menu-item">
                    <Link to="/coupons"
                          className={`menu-link${activeLinkName == 'coupons' ? ' active-link' : ''}`}
                          onClick={() => {
                            setActiveLinkName("coupons")
                          }}
                    >
                      <div className="menu-icon">
                        <i className="fas fa-tags"></i>
                      </div>
                      <span className="menu-title">Coupons</span>
                    </Link>
                  </div>
                )
              }

              {
                (userCan(permissions, 'Cart Items View')) && (
                  <div className="menu-item">
                    <Link to="/cart-items"
                          className={`menu-link${activeLinkName == 'cart-items' ? ' active-link' : ''}`}
                          onClick={() => {
                            setActiveLinkName("cart-items")
                          }}
                    >
                      <div className="menu-icon">
                        <i className="fas fa-shopping-cart"></i>
                      </div>
                      <span className="menu-title">Cart items</span>
                    </Link>
                  </div>
                )
              }

              {
                (userCan(permissions, 'Wishlist Items View')) && (
                  <div className="menu-item">
                    <Link to="/wishlist-items"
                          className={`menu-link${activeLinkName == 'wishlist-items' ? ' active-link' : ''}`}
                          onClick={() => {
                            setActiveLinkName("wishlist-items")
                          }}
                    >
                      <div className="menu-icon">
                        <i className="fas fa-heart"></i>
                      </div>
                      <span className="menu-title">Wishlist items</span>
                    </Link>
                  </div>
                )
              }

              {
                (userCan(permissions, 'Seller Application View')) && (
                  <div className="menu-item">
                    <Link to="/seller-applications"
                          className={`menu-link${activeLinkName == 'seller-applications' ? ' active-link' : ''}`}
                          onClick={() => {
                            setActiveLinkName("seller-applications")
                          }}
                    >
                      <div className="menu-icon">
                        <i className="fas fa-file-alt"></i>
                      </div>
                      <span className="menu-title">Seller Applications</span>
                    </Link>
                  </div>
                )
              }
              {/*end::Menu*/}
            </div>
            {/*end::Aside Menu*/}
          </div>
        </div>
        {/*end::Aside menu*/}
        {/*begin::Footer*/}
        <div className="aside-footer flex-column-auto pb-5" id="kt_aside_footer">
          <div className="aside-user">
            {
              (userCan(permissions, 'Cache Delete')) && (
                <button className="btn btn-danger mx-auto d-block" type="button" onClick={() => clearCache()}>
                  Clear Cache
                </button>
              )
            }
          </div>
        </div>
        {/*end::Footer*/}
        <span
          className={`app-menu-toggle-btn ${menuOpen ? "open-with-menu" : "closed-with-menu"}`}
          title={`${menuOpen ? "Close" : "Open"} Menu`}
          onClick={() => {
            dispatch({type: 'CHANGE_MENUOPENCLOSE'});
          }}
        >
          <i className="fas fa-bars static-icon fs-1"></i>
          <i className="fas fa-chevron-left close-icon fs-1"></i>
          <i className="fas fa-chevron-right open-icon fs-1"></i>
        </span>
      </div>
    </>
  );
}